// extracted by mini-css-extract-plugin
export default {"container":"IP-z","title":"JP-z","link":"KP-z"};